export enum NumberOfCalls {
  Zero = 0,
  One = 1,
}
